import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICandidate, ITag } from '../../../../interfaces/graph-types';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { CandidateService } from '../../../../services/candidate.service';

@Component({
  selector: '[account-candidate]',
  template: require('./account-candidate.component.pug'),
  styles: [require('./account-candidate.component.css').toString()],
})
export class AccountCandidateComponent implements OnInit {
  //candidate$: Observable<ICandidate>;
  candidate: ICandidate;
  routesub: any = null;
  prosub: any = null;

  // -------------------------------------------------------------------
  constructor(
    private watch: WatchAccountService,
    private candidateService: CandidateService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.routesub = this.route.paramMap.subscribe(params => {
      let candidate_id = params.get('candidate_id');

      this.prosub = this.candidateService
        .getCandidateInfo(this.watch.accountId().getValue(), candidate_id)
        .subscribe(response => {
          console.log(response);
          this.candidate = response;
        });
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
    if (this.prosub) {
      this.prosub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  deleteCandidate(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.candidateService.deleteCandidates(
      [this.candidate.id],
      () => {
        this.router.navigate([
          '/account/' + this.watch.accountId().getValue() + '/candidates/list',
        ]);
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  tagging(tag: ITag, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.candidateService.setTag(
      this.watch.accountId().getValue(),
      this.candidate.id,
      tag.id,
      !tag.value,
      () => {
        tag.value = !tag.value;
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  changeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.candidateService.setField(
      this.candidate.id,
      data,
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  changeAttributeDetected(
    data: any,
    newValue: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.candidateService.setAttributeField(
      this.candidate.id,
      data.id,
      data.attributeValueId,
      'value',
      newValue,
      () => {
        onsuccess();
      },
      error => {
        onfailure(error);
      },
    );
    //console.warn(this.candidate);
  }
}
